<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="javascript:void(0)">App General Setting</a>
    </div>
</nav>
<hr/>
<div class="row">
    <div class="col-12 col-md-5">
        <form #f="ngForm" (ngSubmit)="submit()" novalidate>
            <h3>Brand Identity</h3>
            <div class="mb-3">
                <div class="row">
                    <div class="col-8">
                        <label for="icon" class="form-label">Icon</label>
                        <input type="file" class="form-control" id="icon" (change)="getFile($event, 'app_icon')"/>
                    </div>
                    <div class="col-4">
                        <div *ngIf="data.app_icon">
                            <img [src]="data.app_icon" class="w-50" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-8">
                        <label for="logo" class="form-label">Logo</label>
                        <input type="file" class="form-control" id="logo" (change)="getFile($event, 'app_logo')"/>
                    </div>
                    <div class="col-4">
                        <div *ngIf="data.app_logo">
                            <img [src]="data.app_logo" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="app_logo_width" class="form-label">Logo Width (px)</label>
                <input type="text" class="form-control" id="app_logo_width" placeholder="App Logo Width" name="app_logo_width" #app_logo_width="ngModel" [(ngModel)]="data.app_logo_width" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="app_logo_height" class="form-label">Logo Height (px)</label>
                <input type="text" class="form-control" id="app_logo_height" placeholder="App Logo Height" name="app_logo_height" #app_logo_height="ngModel" [(ngModel)]="data.app_logo_height" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="app_logo_mobile_width" class="form-label">Mobile Logo Width (px)</label>
                <input type="text" class="form-control" id="app_logo_mobile_width" placeholder="App Mobile Logo Width" name="app_logo_mobile_width" #app_logo_mobile_width="ngModel" [(ngModel)]="data.app_logo_mobile_width" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="app_logo_mobile_height" class="form-label">Mobile Logo Height (px)</label>
                <input type="text" class="form-control" id="app_logo_mobile_height" placeholder="App Mobile Logo Height" name="app_logo_mobile_height" #app_logo_mobile_height="ngModel" [(ngModel)]="data.app_logo_mobile_height" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="app_name" class="form-label">App Name</label>
                <input type="text" class="form-control" id="app_name" placeholder="App Name" name="app_name" #app_name="ngModel" [(ngModel)]="data.app_name" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="show_app_name" class="form-label">Show App Name Beside Logo</label>
                <select class="form-control" [(ngModel)]="data.show_app_name" name="show_app_name" #show_app_name="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <h3>Design Layout</h3>
            <div class="mb-3">
                <label for="show_language_switcher" class="form-label">Show Language Switcher</label>
                <select class="form-control" [(ngModel)]="data.show_language_switcher" name="show_language_switcher" #show_language_switcher="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="show_drawer_opener" class="form-label">Show Sidebar Drawer</label>
                <select class="form-control" [(ngModel)]="data.show_drawer_opener" name="show_drawer_opener" #show_drawer_opener="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="show_header_marquee_text" class="form-label">Show Header Scrolling Text</label>
                <select class="form-control" [(ngModel)]="data.show_header_marquee_text" name="show_header_marquee_text" #show_header_marquee_text="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="show_body_marquee_text" class="form-label">Show Body Scrolling Text</label>
                <select class="form-control" [(ngModel)]="data.show_body_marquee_text" name="show_body_marquee_text" #show_body_marquee_text="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <h3>SMS Verification</h3>
            <div class="mb-3">
                <label for="require_number_verification" class="form-label">Require Number Verification (Required SMS Service provider integration)</label>
                <select class="form-control" [(ngModel)]="data.require_number_verification" name="require_number_verification" #require_number_verification="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="sms_service_provider" class="form-label">SMS Service Provider</label>
                <select class="form-control" [(ngModel)]="data.sms_service_provider" name="sms_service_provider" #sms_service_provider="ngModel">
                    <option value="">None</option>
                    <option value="isms">ISMS</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="sms_service_provider_username" class="form-label">SMS Service Provider Username</label>
                <input type="text" class="form-control" id="sms_service_provider_username" placeholder="SMS Service Provider Username" name="sms_service_provider_username" #sms_service_provider_username="ngModel" [(ngModel)]="data.sms_service_provider_username" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="sms_service_provider_password" class="form-label">SMS Service Provider Password</label>
                <input type="text" class="form-control" id="sms_service_provider_password" placeholder="SMS Service Provider Password" name="sms_service_provider_password" #sms_service_provider_password="ngModel" [(ngModel)]="data.sms_service_provider_password" maxlength="100" />
            </div>
            <h4>Whatsapp WEB API</h4>
            <div class="mb-3">
                <label for="system_whatsapp_api_url" class="form-label">API URL</label>
                <input type="text" class="form-control" id="system_whatsapp_api_url" placeholder="e.g. http://192.168.1.100:3100" name="system_whatsapp_api_url" #system_whatsapp_api_url="ngModel" [(ngModel)]="systemConfig['whatsapp/api_url']" />
                <small class="text-muted">Base URL of the WhatsApp API service hosted on your VM.</small>
            </div>
            <div class="mb-3">
                <label for="system_whatsapp_api_key" class="form-label">API Key</label>
                <input type="password" class="form-control" id="system_whatsapp_api_key" placeholder="Enter API key" name="system_whatsapp_api_key" #system_whatsapp_api_key="ngModel" [(ngModel)]="systemConfig['whatsapp/api_key']" autocomplete="new-password" />
                <small class="text-muted">Shared API key for the WhatsApp API service (x-api-key header).</small>
            </div>
            <div class="mb-3">
                <button type="button" class="btn btn-primary" (click)="saveSystemConfig()">Save WhatsApp Config</button>
            </div>
            <h3>Design Color</h3>
            <div class="mb-3">
                <label for="app_primary_background_color" class="form-label">Primary Background Color</label>
                <input [style.background]="data.app_primary_background_color" [(colorPicker)]="data.app_primary_background_color" type="text" class="form-control" id="app_primary_background_color" placeholder="App Primary Background Color" name="app_primary_background_color" #app_primary_background_color="ngModel" [(ngModel)]="data.app_primary_background_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_primary_text_color" class="form-label">Primary Text Color</label>
                <input [style.background]="data.app_primary_text_color" [(colorPicker)]="data.app_primary_text_color" type="text" class="form-control" id="app_primary_text_color" placeholder="App Primary Text Color" name="app_primary_text_color" #app_primary_text_color="ngModel" [(ngModel)]="data.app_primary_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_background_color" class="form-label">Header Background Color</label>
                <input [style.background]="data.app_header_background_color" [(colorPicker)]="data.app_header_background_color" type="text" class="form-control" id="app_header_background_color" placeholder="App Header Background Color" name="app_header_background_color" #app_header_background_color="ngModel" [(ngModel)]="data.app_header_background_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_text_color" class="form-label">Header Text Color</label>
                <input [style.background]="data.app_header_text_color" [(colorPicker)]="data.app_header_text_color" type="text" class="form-control" id="app_header_text_color" placeholder="App Header Text Color" name="app_header_text_color" #app_header_text_color="ngModel" [(ngModel)]="data.app_header_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_secondary_background_color" class="form-label">Header Secondary Background Color</label>
                <input [style.background]="data.app_header_secondary_background_color" [(colorPicker)]="data.app_header_secondary_background_color" type="text" class="form-control" id="app_header_secondary_background_color" placeholder="App Header Secondary Background Color" name="app_header_secondary_background_color" #app_header_secondary_background_color="ngModel" [(ngModel)]="data.app_header_secondary_background_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_secondary_text_color" class="form-label">Header Secondary Text Color</label>
                <input [style.background]="data.app_header_secondary_text_color" [(colorPicker)]="data.app_header_secondary_text_color" type="text" class="form-control" id="app_header_secondary_text_color" placeholder="App Header Secondary Text Color" name="app_header_secondary_text_color" #app_header_secondary_text_color="ngModel" [(ngModel)]="data.app_header_secondary_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_link_text_color" class="form-label">Header Link Text Color</label>
                <input [style.background]="data.app_header_link_text_color" [(colorPicker)]="data.app_header_link_text_color" type="text" class="form-control" id="app_header_link_text_color" placeholder="App Header Link Text Color" name="app_header_link_text_color" #app_header_link_text_color="ngModel" [(ngModel)]="data.app_header_link_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_button_color" class="form-label">Header Button Background Color</label>
                <input [style.background]="data.app_header_button_color" [(colorPicker)]="data.app_header_button_color" type="text" class="form-control" id="app_header_button_color" placeholder="App Header Button Background Color" name="app_header_button_color" #app_header_button_color="ngModel" [(ngModel)]="data.app_header_button_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_button_text_color" class="form-label">Header Button Text Color</label>
                <input [style.background]="data.app_header_button_text_color" [(colorPicker)]="data.app_header_button_text_color" type="text" class="form-control" id="app_header_button_text_color" placeholder="App Header Button Text Color" name="app_header_button_text_color" #app_header_button_text_color="ngModel" [(ngModel)]="data.app_header_button_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_header_button_border_color" class="form-label">Header Button Border Color</label>
                <input [style.background]="data.app_header_button_border_color" [(colorPicker)]="data.app_header_button_border_color" type="text" class="form-control" id="app_header_button_border_color" placeholder="App Header Button Border Color" name="app_header_button_border_color" #app_header_button_border_color="ngModel" [(ngModel)]="data.app_header_button_border_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_footer_background_color" class="form-label">Footer Background Color</label>
                <input [style.background]="data.app_footer_background_color" [(colorPicker)]="data.app_footer_background_color" type="text" class="form-control" id="app_footer_background_color" placeholder="App Footer Background Color" name="app_footer_background_color" #app_footer_background_color="ngModel" [(ngModel)]="data.app_footer_background_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_footer_text_color" class="form-label">Footer Text Color</label>
                <input [style.background]="data.app_footer_text_color" [(colorPicker)]="data.app_footer_text_color" type="text" class="form-control" id="app_footer_text_color" placeholder="App Footer Text Color" name="app_footer_text_color" #app_footer_text_color="ngModel" [(ngModel)]="data.app_footer_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_primary_button_color" class="form-label">Primary button Color</label>
                <input [style.background]="data.app_primary_button_color" [(colorPicker)]="data.app_primary_button_color" type="text" class="form-control" id="app_primary_button_color" placeholder="App Primary Button Color" name="app_primary_button_color" #app_primary_button_color="ngModel" [(ngModel)]="data.app_primary_button_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_primary_button_text_color" class="form-label">Primary button Text Color</label>
                <input [style.background]="data.app_primary_button_text_color" [(colorPicker)]="data.app_primary_button_text_color" type="text" class="form-control" id="app_primary_button_text_color" placeholder="App Primary Button Text Color" name="app_primary_button_text_color" #app_primary_button_text_color="ngModel" [(ngModel)]="data.app_primary_button_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_secondary_button_color" class="form-label">Secondary button Color</label>
                <input [style.background]="data.app_secondary_button_color" [(colorPicker)]="data.app_secondary_button_color" type="text" class="form-control" id="app_secondary_button_color" placeholder="App Secondary Button Color" name="app_secondary_button_color" #app_secondary_button_color="ngModel" [(ngModel)]="data.app_secondary_button_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_secondary_button_text_color" class="form-label">Secondary button Text Color</label>
                <input [style.background]="data.app_secondary_button_text_color" [(colorPicker)]="data.app_secondary_button_text_color" type="text" class="form-control" id="app_secondary_button_text_color" placeholder="App Secondary Button Text Color" name="app_secondary_button_text_color" #app_secondary_button_text_color="ngModel" [(ngModel)]="data.app_secondary_button_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_link_text_color" class="form-label">Link Text Color</label>
                <input [style.background]="data.app_link_text_color" [(colorPicker)]="data.app_link_text_color" type="text" class="form-control" id="app_link_text_color" placeholder="App Link Text Color" name="app_link_text_color" #app_link_text_color="ngModel" [(ngModel)]="data.app_link_text_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_contact_background_color" class="form-label">Contact Us Popup Background Color</label>
                <input [style.background]="data.app_contact_background_color" [(colorPicker)]="data.app_contact_background_color" type="text" class="form-control" id="app_contact_background_color" placeholder="App Contact Us Background Color" name="app_contact_background_color" #app_contact_background_color="ngModel" [(ngModel)]="data.app_contact_background_color" maxlength="100" />
            </div>
            <div class="mb-3">
                <label for="app_contact_text_color" class="form-label">Contact Us Popup Text Color</label>
                <input [style.background]="data.app_contact_text_color" [(colorPicker)]="data.app_contact_text_color" type="text" class="form-control" id="app_contact_text_color" placeholder="App Contact Us Text Color" name="app_contact_text_color" #app_contact_text_color="ngModel" [(ngModel)]="data.app_contact_text_color" maxlength="100" />
            </div>
            <h3>Theme Setting</h3>
            <div class="mb-3">
                <label for="theme_mobile_only" class="form-label">Mobile Size Only</label>
                <select class="form-control" [(ngModel)]="data.theme_mobile_only" name="theme_mobile_only" #theme_mobile_only="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="theme_header" class="form-label">Header Theme</label>
                <select class="form-control" [(ngModel)]="data.theme_header" name="theme_header" #theme_header="ngModel">
                    <option value="1">Header 1 (Default)</option>
                    <option value="2">Header 2</option>
                    <option value="3">Header 3</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="theme_category" class="form-label">Category Theme</label>
                <select class="form-control" [(ngModel)]="data.theme_category" name="theme_category" #theme_category="ngModel">
                    <option value="1">Category on Top (Default)</option>
                    <option value="2">Category at Side</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="game_grid" class="form-label">Product List Type</label>
                <select class="form-control" [(ngModel)]="data.game_grid" name="game_grid" #game_grid="ngModel">
                    <option value="1">Grid</option>
                    <option value="0">List (Some of the Theme do not support list type)</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="theme_dashboard_category" class="form-label">Show Category on Home Page Top</label>
                <select class="form-control" [(ngModel)]="data.theme_dashboard_category" name="theme_dashboard_category" #theme_dashboard_category="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="theme_dashboard_game" class="form-label">Show Game & Game Category on Home Page</label>
                <select class="form-control" [(ngModel)]="data.theme_dashboard_game" name="theme_dashboard_game" #theme_dashboard_game="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="show_footer_icon_text" class="form-label">Show Footer Icon Text</label>
                <select class="form-control" [(ngModel)]="data.show_footer_icon_text" name="show_footer_icon_text" #show_footer_icon_text="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="show_fullname_warning" class="form-label">Show fullname warining during register</label>
                <select class="form-control" [(ngModel)]="data.show_fullname_warning" name="show_fullname_warning" #show_fullname_warning="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="default_password" class="form-label">Use Default Password During Register</label>
                <select class="form-control" [(ngModel)]="data.default_password" name="default_password" #default_password="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-12">
                        <label for="theme_dashboard_banner_1" class="form-label">Home Banner 1</label>
                        <input type="file" class="form-control" id="theme_dashboard_banner_1" (change)="getFile($event, 'theme_dashboard_banner_1')"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div *ngIf="data.theme_dashboard_banner_1">
                            <img [src]="data.theme_dashboard_banner_1" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-12">
                        <label for="theme_dashboard_banner_2" class="form-label">Home Banner 2</label>
                        <input type="file" class="form-control" id="theme_dashboard_banner_2" (change)="getFile($event, 'theme_dashboard_banner_2')"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div *ngIf="data.theme_dashboard_banner_2">
                            <img [src]="data.theme_dashboard_banner_2" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-12">
                        <label for="theme_dashboard_banner_3" class="form-label">Home Banner3</label>
                        <input type="file" class="form-control" id="theme_dashboard_banner_3" (change)="getFile($event, 'theme_dashboard_banner_3')"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div *ngIf="data.theme_dashboard_banner_3">
                            <img [src]="data.theme_dashboard_banner_3" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <h3>Other</h3>
            <div class="mb-3">
                <label for="number_of_game_per_row" class="form-label">Number of Game per Row</label>
                <select class="form-control" [(ngModel)]="data.number_of_game_per_row" name="number_of_game_per_row" #number_of_game_per_row="ngModel">
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">6</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="number_of_game_per_row_mobile" class="form-label">Number of Game per Row (Mobile Screen)</label>
                <select class="form-control" [(ngModel)]="data.number_of_game_per_row_mobile" name="number_of_game_per_row_mobile" #number_of_game_per_row_mobile="ngModel">
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">6</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="number_of_category_per_row" class="form-label">Number of Category per Row</label>
                <select class="form-control" [(ngModel)]="data.number_of_category_per_row" name="number_of_category_per_row" #number_of_category_per_row="ngModel">
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">6</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="number_of_category_per_row_mobile" class="form-label">Number of Category per Row (Mobile Screen)</label>
                <select class="form-control" [(ngModel)]="data.number_of_category_per_row_mobile" name="number_of_category_per_row_mobile" #number_of_category_per_row_mobile="ngModel">
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">6</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="slider_timer" class="form-label">Slider Timer (Second)</label>
                <input type="number" class="form-control" id="slider_timer" placeholder="Slider Timer" name="slider_timer" #slider_timer="ngModel" [(ngModel)]="data.slider_timer"/>
            </div>
            <div class="mb-3">
                <label for="min_deposit" class="form-label">Min Deposit</label>
                <input type="number" class="form-control" id="min_deposit" placeholder="Minimum Deposit" name="min_deposit" #min_deposit="ngModel" [(ngModel)]="data.min_deposit" />
            </div>
            <div class="mb-3">
                <label for="min_withdraw" class="form-label">Min Withdraw</label>
                <input type="number" class="form-control" id="min_withdraw" placeholder="Minimum Withdraw" name="min_withdraw" #min_withdraw="ngModel" [(ngModel)]="data.min_withdraw" />
            </div>
            <h3>Referral Wallet Transfer</h3>
            <div class="mb-3">
                <label for="referral_transfer_enabled" class="form-label">Enable Self-Service Referral Wallet Transfer</label>
                <select class="form-control" id="referral_transfer_enabled" name="referral_transfer_enabled" #referral_transfer_enabled="ngModel" [(ngModel)]="data.referral_transfer_enabled">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
                <small class="form-text text-muted">Master switch for the player-facing "Transfer to Wallet" button/endpoint. Defaults to No (disabled). The admin override is unaffected by this switch.</small>
            </div>
            <div class="mb-3">
                <label for="referral_transfer_multiplier" class="form-label">Wager Multiplier (× transfer amount)</label>
                <input type="number" step="0.01" min="0" class="form-control" id="referral_transfer_multiplier" placeholder="1" name="referral_transfer_multiplier" #referral_transfer_multiplier="ngModel" [(ngModel)]="data.referral_transfer_multiplier" />
                <small class="form-text text-muted">Turnover required to transfer = multiplier × amount. Defaults to 1 if blank or non-positive.</small>
            </div>
            <div class="mb-3">
                <label for="referral_transfer_min" class="form-label">Minimum Transfer Amount</label>
                <input type="number" step="0.01" min="0" class="form-control" id="referral_transfer_min" placeholder="1" name="referral_transfer_min" #referral_transfer_min="ngModel" [(ngModel)]="data.referral_transfer_min" />
                <small class="form-text text-muted">Defaults to 1 if blank or non-positive.</small>
            </div>
            <div class="mb-3">
                <label for="referral_transfer_wager_required" class="form-label">Require Wager for Self-Service Transfer</label>
                <select class="form-control" id="referral_transfer_wager_required" name="referral_transfer_wager_required" #referral_transfer_wager_required="ngModel" [(ngModel)]="data.referral_transfer_wager_required">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
                <small class="form-text text-muted">When No, players bypass the wager gate. The admin override always bypasses it.</small>
            </div>
            <h3>Icon</h3>
            <div class="mb-3">
                <label for="show_menu_icon" class="form-label">Show menu Icon</label>
                <select class="form-control" [(ngModel)]="data.show_menu_icon" name="show_menu_icon" #show_menu_icon="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="home_icon" class="form-label">Home Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="home_icon" (change)="getFile($event, 'app_home_icon')"/>        
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_home_icon">
                            <img [src]="data.app_home_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="angpow_icon" class="form-label">Angpow Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="angpow_icon" (change)="getFile($event, 'app_angpow_icon')"/>        
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_angpow_icon">
                            <img [src]="data.app_angpow_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="promotion_icon" class="form-label">Promotion Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="promotion_icon" (change)="getFile($event, 'app_promotion_icon')"/>        
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_promotion_icon">
                            <img [src]="data.app_promotion_icon" class="w-100" />
                        </div>
                    </div>
                </div>                
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="register_icon" class="form-label">Register Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="register_icon" (change)="getFile($event, 'app_register_icon')"/>        
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_register_icon">
                            <img [src]="data.app_register_icon" class="w-100" />
                        </div>
                    </div>
                </div>                
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="login_icon" class="form-label">Login Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="login_icon" (change)="getFile($event, 'app_login_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_login_icon">
                            <img [src]="data.app_login_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="chat_icon" class="form-label">Chat (100px x 100px png)</label>
                        <input type="file" class="form-control" id="chat_icon" (change)="getFile($event, 'app_chat_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_chat_icon">
                            <img [src]="data.app_chat_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="deposit_icon" class="form-label">Deposit Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="deposit_icon" (change)="getFile($event, 'app_deposit_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_deposit_icon">
                            <img [src]="data.app_deposit_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="withdraw_icon" class="form-label">Withdraw Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="withdraw_icon" (change)="getFile($event, 'app_withdraw_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_withdraw_icon">
                            <img [src]="data.app_withdraw_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="app_wallet_icon" class="form-label">Wallet Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="app_wallet_icon" (change)="getFile($event, 'app_wallet_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_wallet_icon">
                            <img [src]="data.app_wallet_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="profile_icon" class="form-label">Profile Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="profile_icon" (change)="getFile($event, 'app_profile_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.app_profile_icon">
                            <img [src]="data.app_profile_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="show_floating_chat_icon" class="form-label">Show Floating Chat Icon</label>
                <select class="form-control" [(ngModel)]="data.show_floating_chat_icon" name="show_floating_chat_icon" #show_floating_chat_icon="ngModel">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="chat_icon_float" class="form-label">Chat Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="chat_icon_float" (change)="getFile($event, 'chat_icon_float')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.chat_icon_float">
                            <img [src]="data.chat_icon_float" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="whatsapp_icon" class="form-label">Whatsapp Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="whatsapp_icon" (change)="getFile($event, 'whatsapp_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.whatsapp_icon">
                            <img [src]="data.whatsapp_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="telegram_icon" class="form-label">Telegram Icon (100px x 100px png)</label>
                        <input type="file" class="form-control" id="telegram_icon" (change)="getFile($event, 'telegram_icon')"/>
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.telegram_icon">
                            <img [src]="data.telegram_icon" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="row">
                    <div class="col-10">
                        <label for="contact_us_image" class="form-label">Contact Us Image</label>
                        <input type="file" class="form-control" id="contact_us_image" (change)="getFile($event, 'contact_us_image')"/>        
                    </div>
                    <div class="col-2">
                        <div *ngIf="data.contact_us_image">
                            <img [src]="data.contact_us_image" class="w-100" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label for="contact_us_image_width" class="form-label">Contact Us Image Width (px)</label>
                <input type="text" class="form-control" id="contact_us_image_width" placeholder="Contact Us Image Width" name="contact_us_image_width" #contact_us_image_width="ngModel" [(ngModel)]="data.contact_us_image_width" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="contact_us_image_height" class="form-label">Contact Us Image Height (px)</label>
                <input type="text" class="form-control" id="contact_us_image_height" placeholder="Contact Us Image Height" name="contact_us_image_height" #contact_us_image_height="ngModel" [(ngModel)]="data.contact_us_image_height" maxlength="5" />
            </div>
            <div class="mb-3">
                <label for="contact_us_whatsapp" class="form-label">Contact Us (Whatsapp)</label>
                <input type="text" class="form-control" id="contact_us_whatsapp" placeholder="Contact Us (Whatsapp)" name="contact_us_whatsapp" #contact_us_whatsapp="ngModel" [(ngModel)]="data.contact_us_whatsapp" maxlength="50" />
            </div>
            <div class="mb-3">
                <label for="contact_us_telegram" class="form-label">Contact Us (Telegram))</label>
                <input type="text" class="form-control" id="contact_us_telegram" placeholder="Contact Us (Telegram)" name="contact_us_telegram" #contact_us_telegram="ngModel" [(ngModel)]="data.contact_us_telegram" maxlength="50" />
            </div>
            <h3>Write Up Section</h3>
            <div class="mb-3">
                <label for="scrolling_text" class="form-label">Scrolling Text</label>
                <input type="text" class="form-control" id="scrolling_text" placeholder="Scrolling Text" name="scrolling_text" #scrolling_text="ngModel" maxlength="250" [(ngModel)]="data.scrolling_text"/>
            </div>
            <div class="mb-3">
                <label for="app_writeup_main_bottom" class="form-label">Main Page Bottom</label>
                <angular-editor id="app_writeup_main_bottom" [placeholder]="'Main Page Bottom'" [(ngModel)]="data.app_writeup_main_bottom" ></angular-editor>
            </div>

            <hr/>
            <div class="col-auto">
                <button type="submit" class="btn btn-primary mb-3 w-100">Update</button>
            </div>
        </form>
    </div>
</div>